import React, { Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import { Grid, Divider } from "@material-ui/core";
import { getConfigItemByParentId } from "store/state/configItems";
import { FREQUENCY } from "constants/configItemParents";
import loanTypes from "constants/loanTypes";
import { transformNumber } from "utils/transformNumber";
import TypeAheadDropdown from "../Components/TypeAheadDropdown";
import GridTextInput from "../Components/GridTextInput";
import GridPercentInput from "../Components/GridPercentInput";
import { setConfigItemListState } from "../util";
import SectionTitle from '../Components/SectionTitle';

class Covenants extends React.Component {
  state = {
    reportingFrequencies: [],
    debtYieldAsIs: "",
    debtYieldStabilized: "",
    ltvAsIs: "",
    ltvStabilized: "",
    ltc: "",
    occupancy: ""
  };

  static getDerivedStateFromProps(props, state) {
    const { loan } = props;
    return {
      debtYieldAsIs: loan.debtYieldAsIs || loan.debtYieldAsIs === 0 ? loan.debtYieldAsIs : "",
      debtYieldStabilized: loan.debtYieldStabilized || loan.debtYieldStabilized === 0 ? loan.debtYieldStabilized : "",
      ltvAsIs: loan.ltvAsIs || loan.ltvAsIs === 0 ? loan.ltvAsIs : "",
      ltvStabilized: loan.ltvStabilized || loan.ltvStabilized === 0 ? loan.ltvStabilized : "",
      ltc: loan.ltc || loan.ltc === 0 ? loan.ltc : "",
      occupancy: loan.occupancy || loan.occupancy === 0 ? loan.occupancy : ""
    };
  }

  componentDidMount() {
    this.props.getConfigItemByParentId({
      id: FREQUENCY
    });
  }

  componentDidUpdate = () => {
    if (this.props.configItems && this.props.configItems.configItemByParent) {
      setConfigItemListState(FREQUENCY, "reportingFrequencies", this);
    }
  };

  render() {
    const {
      loan,
      handleChange,
      handleTextChange,
      isNewLoan,
      isEditing,
      isInitialized
    } = this.props;

    const isValueAdd = loan.loanTypeId === loanTypes.VALUE_ADD;
    const isConstruction = loan.loanTypeId === loanTypes.CONSTRUCTION;
    const isOther =
      loan.loanTypeId &&
      loan.loanTypeId !== loanTypes.CONSTRUCTION &&
      loan.loanTypeId !== loanTypes.VALUE_ADD;

    return (
      <Fragment>
        <span id="loan_covenants">
        <Grid hidden={!isInitialized} item xs={7}>
            <SectionTitle>Covenants</SectionTitle>
        </Grid>
        <Grid container item={true} xs={12}>
          <GridTextInput
            name="dscrAsIs"
            label="DSCR (As-Is)"
            type="number"
            value={loan.dscrAsIs}
            onChange={handleTextChange}
            isEditing={isEditing}
            shouldShow={isInitialized && !isConstruction && !isOther}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridTextInput
            name="dscrStabilized"
            label={isValueAdd ? "DSCR (Stabilized)" : "DSCR"}
            type="number"
            value={loan.dscrStabilized}
            onChange={handleTextChange}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridPercentInput
            name="debtYieldAsIs"
            label="Debt Yield (As-Is)"
            value={this.state.debtYieldAsIs}
            onBlur={item => {
              handleTextChange({
                target: {
                  name: "debtYieldAsIs",
                  value:
                    item.target.value === ""
                      ? ""
                      : transformNumber(item.target.value)
                }
              });
            }}
            isEditing={isEditing}
            shouldShow={isInitialized && !isConstruction && !isOther}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridPercentInput
            name="debtYieldStabilized"
            label={isValueAdd ? "Debt Yield (Stabilized)" : "Debt Yield"}
            value={this.state.debtYieldStabilized}
            onBlur={item => {
              handleTextChange({
                target: {
                  name: "debtYieldStabilized",
                  value:
                    item.target.value === ""
                      ? ""
                      : transformNumber(item.target.value)
                }
              });
            }}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridPercentInput
            name="ltvAsIs"
            label="LTV (As-Is)"
            value={this.state.ltvAsIs}
            onBlur={item => {
              handleTextChange({
                target: {
                  name: "ltvAsIs",
                  value:
                    item.target.value === ""
                      ? ""
                      : transformNumber(item.target.value)
                }
              });
            }}
            isEditing={isEditing}
            shouldShow={isInitialized && !isConstruction && !isOther}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridPercentInput
            name="ltvStabilized"
            label={isValueAdd ? "LTV (Stabilized)" : "LTV"}
            value={this.state.ltvStabilized}
            onBlur={item => {
              handleTextChange({
                target: {
                  name: "ltvStabilized",
                  value:
                    item.target.value === ""
                      ? ""
                      : transformNumber(item.target.value)
                }
              });
            }}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridPercentInput
            name="ltc"
            label="LTC"
            value={this.state.ltc}
            onBlur={item => {
              handleTextChange({
                target: {
                  name: "ltc",
                  value:
                    item.target.value === ""
                      ? ""
                      : transformNumber(item.target.value)
                }
              });
            }}
            isEditing={isEditing}
            shouldShow={isInitialized && !isOther}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <GridPercentInput
            name="occupancy"
            label="Occupancy"
            value={this.state.occupancy}
            onBlur={item => {
              handleTextChange({
                target: {
                  name: "occupancy",
                  value:
                    item.target.value === ""
                      ? ""
                      : transformNumber(item.target.value)
                }
              });
            }}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>
        <Grid container item={true} xs={12}>
          <TypeAheadDropdown
            name="reportingFrequencyId"
            label="Reporting Frequency"
            placeholder="Select a Reporting Frequency"
            options={this.state.reportingFrequencies}
            value={loan.reportingFrequencyId}
            handleChange={data => handleChange("reportingFrequencyId", data)}
            isEditing={isEditing}
            shouldShow={isInitialized}
          />
        </Grid>        
        </span>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { loading, configItems } = state;
  return {
    loading,
    configItems
  };
};

export default compose(
  connect(
    mapStateToProps,
    {
      getConfigItemByParentId
    }
  )  
)(Covenants);
